import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class LoginService {
apiUrl = environment.apiUrl;
  constructor(private http:HttpClient) { }
  login(data:any){
return this.http.post(`${this.apiUrl}/auth/login`,data)
  }
  getpublickey(){
    return this.http.get(`${this.apiUrl}/auth/public-key`)
  }
}
